import { notification } from '@pu/mpp-ui/notifications';
import { EMaintenanceStatusType } from 'core/model/enums';
import type { TUpdateMaintenanceParams } from 'core/model/interfaces/maintenance';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IMaintenanceState } from '../types';

export const updateMaintenance = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/updateMaintenance`,
  async (params: { data: TUpdateMaintenanceParams }) => {
    try {
      const { data } = params;

      await apiService.maintenance.updateMaintenance(data);

      notification.success(
        data.status === EMaintenanceStatusType.INACTIVE
          ? 'Se ha desactivado la pantalla de mantenimiento correctamente.'
          : 'Se han asignado las opciones necesarias para la pantalla de mantenimiento.',
      );
    } catch (error) {
      const errorMessage = handleErrorMessage(
        error,
        'No se pudo actualizar la pantalla. Verifica que todos los campos estén completos.',
      );

      showNotificationError(errorMessage);

      throw error;
    }
  },
);

export const updateMaintenanceReducer: TSliceExtraReducer<IMaintenanceState> = builder =>
  builder
    .addCase(updateMaintenance.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(updateMaintenance.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(updateMaintenance.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
